import React, { useState, createContext } from "react";
import tagData from "./TagData";

export const TagsContext = createContext();

export const TagsContextProvider = (props) => {
    const [data, setData] = useState(tagData);

    return <TagsContext.Provider value={{contextData: [data, setData]}}>{props.children}</TagsContext.Provider>
}